export enum CarrierComparisonType {

    wtwEvaluation = 0,

    wtwRenewal = 1,

    carrierRenewal = 2,

}